<script setup lang="ts">
    interface ProductDetailLineProps {
        label: string;
        value: string | null;
        prefix?: string;
    }
    defineProps<ProductDetailLineProps>();
</script>
<template>
    <div class="atm-product-detail-line flex flex-wrap items-center justify-between gap-2">
        <span>{{ label }}:</span>
        <span class="text-right">
            <template v-if="prefix">{{ prefix }}</template>
            {{ value }}
        </span>
    </div>
</template>
